import React from 'react';
import { Header as SharedHeader } from '@rcw/ui';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';

/* Thin wrapper over the shared header in @rcw/ui. Everything app-scoped — the redux
 * selector shape and AuthContext — lives here, so the shared component stays pure. */
export function Header() {
  const user = useSelector((state) => state.user.userInfo);
  const { signinRedirect, signoutRedirect } = useAuth();
  const navigate = useNavigate();

  return (
    <SharedHeader
      user={user}
      navigate={navigate}
      accountHref={`${process.env.REACT_APP_BASE_PATH}/account-detail`}
      onSignIn={signinRedirect}
      onSignOut={signoutRedirect}
    />
  );
}
